import React, {useEffect, useState} from 'react';
import './blog.css'
import {Col, Container, Row} from "react-bootstrap";
import BlogCard from "../../components/accesories/card/BlogCard";
import Pagination from 'react-bootstrap/Pagination';
import PageHeader from "../../layouts/home/PageHeader";
import SearchBox from "../../components/accesories/search/SearchBox";
import Categories from "../../components/accesories/sideElements/Categories";
import apiRequest from "../../services/Axios/Configs/configs";
import {useData} from "../../context/DataContext";
import useHandleRequest from "../../custom_hooks/useHandleRequest";


function Blog(props) {

    const [blogs, setBlogs] = useState([]);
    const [pagination, setPagination] = useState([]);
    const {data, fetchData, loading} = useData();
    const [categories, setCategories] = useState([])
    const {handleRequestAndNavigate} = useHandleRequest();


    useEffect(() => {
        if (data.blogs.length === 0) {  // چک می‌کنیم که آرایه خالی نباشد
            fetchData("blogs", "blogs/");
        } else {
            setBlogs(data.blogs.results);
            setPagination(data.blogs.pagination)
        }
    }, [data.blogs]); // وابسته به `data.blogs`

    useEffect(() => {
        if (data.blogsCategory.length === 0) {  // چک می‌کنیم که آرایه خالی نباشد
            fetchData("blogsCategory", "blogs/blog-category/");
        } else {
            setCategories(data.blogsCategory);
        }
    }, [data.blogsCategory]); // وابسته به `data.blogs`

    const handlePageChange = (e, newPage) => {
        handleRequestAndNavigate(e, `/blogs/?page=${newPage}`, `blogs/?page=${newPage}`, 'blogs')
    }

    return (
        <>
            <PageHeader mainTitle={'مطالب جالبو برات جدا کردیم'} currentPage={'بلاگ داپا'}
                        navigationLinks={[{title: 'صفحه اصلی', href: '/'}]}/>
            <Container className={'blog-content-container p-5'} fluid>
                <Row className={'content-main-row'}>
                    <Col xl={2} lg={3} sm={12} className={'content-right-col'}>
                        <Row className={'d-flex flex-column justify-content-center align-items-center'}>
                            <Col className={'up-part mb-3'}>
                                <SearchBox/>
                            </Col>
                            <Col className={'down-part'}>
                                <Categories bgColor={'#FFEFF8FF'} categories={categories} directory={'blogs'}/>
                            </Col>
                        </Row>
                    </Col>
                    <Col xl={10} lg={9} sm={12} className={'content-left-col'}>
                        <Row className={'content-left-col-row row-gap-xxl-5 row-gap-xl-3'}>
                            {blogs.map(blog => (
                                <BlogCard key={blog.id} to={blog.id} time={blog.publication_date}
                                          category={blog.category}
                                          title={blog.title}
                                          description={blog.summary}
                                          image={blog.thumbnail}
                                />

                            ))}

                        </Row>
                    </Col>
                </Row>
                <Row className={''}>
                    <Pagination className="my-custom-pagination mt-5">

                        {/*<Pagination.First onClick={() => fetchData("blogs", "blog/", 1)} disabled={pagination.current_page === 1} />*/}
                        {(pagination.total_pages > 5 && pagination.current_page !== 1) &&
                            <Pagination.First onClick={(e) => handlePageChange(e, 1)}
                                              disabled={pagination.current_page === 1}/>}
                        {/*<Pagination.Prev onClick={() => fetchData("blogs", "blog/", pagination.current_page - 1)} disabled={pagination.current_page === 1} />*/}
                        {pagination.current_page !== 1 &&
                            <Pagination.Prev onClick={(e) => handlePageChange(e, pagination.current_page - 1)}
                                             disabled={pagination.current_page === 1}/>}


                        {pagination.current_page > 2 &&
                            <Pagination.Item onClick={(e) => handlePageChange(e, 1)}>1</Pagination.Item>}
                        {pagination.current_page > 3 && <Pagination.Ellipsis/>}

                        {pagination.current_page > 1 && (
                            /*<Pagination.Item onClick={() => fetchData("blogs", "blog/", pagination.current_page - 1)}>
                                {pagination.current_page - 1}
                            </Pagination.Item>*/
                            <Pagination.Item onClick={(e) => handlePageChange(e, pagination.current_page - 1)}>
                                {pagination.current_page - 1}
                            </Pagination.Item>
                        )}

                        <Pagination.Item active>{pagination.current_page}</Pagination.Item>

                        {pagination.current_page < pagination.total_pages && (
                            /* <Pagination.Item onClick={() => fetchData("blogs", "blog/", pagination.current_page + 1)}>
                                 {pagination.current_page + 1}
                             </Pagination.Item>*/
                            <Pagination.Item onClick={(e) => handlePageChange(e, pagination.current_page + 1)}>
                                {pagination.current_page + 1}
                            </Pagination.Item>
                        )}

                        {pagination.current_page < pagination.total_pages - 2 && <Pagination.Ellipsis/>}
                        {pagination.current_page < pagination.total_pages - 1 && (
                            /* <Pagination.Item onClick={() => fetchData("blogs", "blog/", pagination.total_pages)}>
                                 {pagination.total_pages}
                             </Pagination.Item>*/
                            <Pagination.Item onClick={(e) => handlePageChange(e, pagination.total_pages)}>
                                {pagination.total_pages}
                            </Pagination.Item>
                        )}

                        {/*<Pagination.Next onClick={() => fetchData("blogs", "blog/", pagination.current_page + 1)} disabled={pagination.current_page === pagination.total_pages} />*/}

                        {pagination.current_page !== pagination.total_pages &&
                            <Pagination.Next onClick={(e) => handlePageChange(e, pagination.current_page + 1)}
                                             disabled={pagination.current_page === pagination.total_pages}/>}

                        {/*<Pagination.Last onClick={() => fetchData("blogs", "blog/", pagination.total_pages)} disabled={pagination.current_page === pagination.total_pages} />*/}
                        {(pagination.total_pages > 5 && pagination.current_page !== pagination.total_pages) &&
                            <Pagination.Last onClick={(e) => handlePageChange(e, pagination.total_pages)}
                                             disabled={pagination.current_page === pagination.total_pages}/>}
                    </Pagination>
                </Row>
            </Container>
        </>
    );
}

export default Blog;